module.exports = __webpack_public_path__ + "static/img/pizza_header.191b24c.jpg";